import React from 'react'
import mb from './photolic/moneybach25.jpg'
import './image.css'
const Moneyback25 = () => {
  return (
    <div>
        <img src={mb} alt="" className='eimg'/>
    </div>
  )
}

export default Moneyback25
